import { render, staticRenderFns } from "./FotoSliderModal.vue?vue&type=template&id=4de5e731&"
import script from "./FotoSliderModal.vue?vue&type=script&lang=js&"
export * from "./FotoSliderModal.vue?vue&type=script&lang=js&"
import style0 from "./FotoSliderModal.vue?vue&type=style&index=0&id=4de5e731&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports